import { render, staticRenderFns } from "./AttentionLabel.vue?vue&type=template&id=03ca4524&scoped=true&"
import script from "./AttentionLabel.vue?vue&type=script&lang=js&"
export * from "./AttentionLabel.vue?vue&type=script&lang=js&"
import style0 from "./AttentionLabel.vue?vue&type=style&index=0&id=03ca4524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca4524",
  null
  
)

export default component.exports